import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { ScoutForm } from '@/components/forms/scout-form'
import { ApplicationShell } from '@/components/forms/application-shell'

const STEPS = [
    'Our team reads every application personally and replies within two weeks.',
    'If it feels like a fit, we have a short call about your work and the designers you rate.',
    'Once you are in, you see open briefs and make your first introduction whenever you are ready.'
]

const ApplyToScout: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Scout application'
                description='Apply to become a Kerning scout. Recommend the designers you already admire, make private introductions and earn when a placement lands.'
            />

            <ApplicationShell
                title='Apply to become a scout'
                intro='Tell us a little about your work and the designers you believe in. There are no quotas and no fees to join.'
                steps={STEPS}
            >
                <ScoutForm />
            </ApplicationShell>
        </Layout>
    )
}

export default ApplyToScout
